import {SirinaOkna} from 'src/assets/js/globalne_funkcije/SirinaOkna.js'
export const PrikazVsebine = {
  mixins: [SirinaOkna],
  data () {
    return {
      mejnaSirinaTabela: 1407,
      prikazTabele: '1'
    }
  },
  mounted () {
    this.SirinaOknaPresegaVrednostTabela()
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednostTabela)
    })
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SirinaOkna.js